import './../scss/style.scss';
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies';
import { initOffcanvas } from './shared/offvanvas';
import { initBoocarousel } from './shared/boocarousel';
import { initModvideo } from './shared/modvideo';
import { initBrandAnimation } from './lwt/brand_animation';
import { loadingSequence } from './loading';

WCAG.init()
initCommon()
initCookies()
initOffcanvas()
initModvideo()
initBoocarousel()
initBrandAnimation()
loadingSequence()
